import http from './http'

// 获取列表
export function pageList (data) {
  return http.get('/client/share/user/pagelist?'+data)
}

// 删除版本
export function removeVersion (key, version) {
  return http.delete(`/client/sync/${key}/${version}`)
}

// 删除分享项
export function removeSync (key) {
  return http.delete(`/client/sync/${key}`)
}

export function removeShare (key) {
  return http.delete(`/client/share/${key}`)
}

export function getDetail (key) {
  return http.get(`/client/share/${key}`)
}